import { useAuth } from '../hooks/useAuth';
import background from '../assets/background-ops.jpg';
import PageTitle from '../components/UtilityHelpers/PageTitle';
import { useNavigate, useLocation } from 'react-router-dom';

const Login = () => {    
    const auth = useAuth();
    const location = useLocation();

    const login = async () => {
        const result = await auth?.authService.authorize();        
    }

    console.log(location);

    if(location.state?.from) {
        const locationPath = location.state?.from?.pathname + location.state?.from?.search;
        window.localStorage.setItem('redirectAfterLogin', locationPath);
    }

    return (
        <>
            <PageTitle title="OPS | Login" />
            <div style={{backgroundImage: `url(${background})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat'}}>
                <div className="backdrop-blur-sm">
                    <div className="relative flex min-h-screen flex-col justify-center overflow-hidden py-6 sm:py-12">
                        <div className="text-center mb-5 text-white text-2xl font-semibold">Online Purchasing System (OPS)</div>
                        <div className='ml-5 mr-5 relative bg-white px-6 pt-10 pb-8 shadow-xl ring-1 ring-gray-900/5 sm:mx-auto sm:max-w-lg sm:rounded-lg sm:px-10 border-2 border-gray-800 flex justify-center flex-col'>
                        <div className="mb-5 text-center">School of Computer Science</div>
                        <button  className="pl-10 pr-10 pb-2 pt-2 bg-gray-800 text-white rounded-md text-center" onClick={login}>Login with UoA UPI</button>
                        </div>
                        <div className="text-center mb-1 text-white text-2xl font-semibold mt-5 flex justify-center">                    
                        </div>
                        <div className="text-center mb-5 text-white text-lg font-thin"><div className="date_sumission_deadline"></div></div>                    
                    </div>                
                </div>
            </div>
        </>
    )   
}

export default Login;